import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { BackendNotFoundIcon } from "../../../icons/errors";

export const BackendNotFoundError: FC<IErrorComponent> = (props) => {
  const message = "Запрашиваемые данные не найдены."
    + " Возможно, они были удалены или перемещены";

  return (
    <ErrorTemplate
      {...props}
      icon={BackendNotFoundIcon}
      header="Ничего не найдено"
      message={message}
      showReloadButton={false}
    />
  );
};
